import React from "react";

const Card = ({
  title,
  count,
  currency,
  color,
  textColor,
  customContent,
  tag,
  icon,
}) => {
  return (
    <div
      className="p-6 w-full h-full rounded-2xl border border-purple-400 cursor-pointer hover:scale-[101%] transition-transform duration-300 flex gap-4 bg-white shadow-md"
     
    >
      {/* Icon */}
      <div className="size-16 flex items-center justify-center rounded-2xl bg-gradient-to-r from-pink-600 to-violet-600 text-white text-3xl shadow-md">
        {icon}
      </div>

      {/* Title + Count (same column like first JSX) */}
      <div className="flex flex-col">
        <h3 className="text-sm font-medium text-gray-600 truncate">{title}</h3>

        {customContent ? (
          <div className="mt-2">{customContent}</div>
        ) : (
          <p className="text-2xl font-bold text-purple-800 mt-1">
            {count} {currency}{" "}
            <span
              className={`${
                tag === "receipts" || tag === "receipt"
                  ? "text-xs"
                  : "text-purple-800"
              }`}
            >
              {tag === "receipts" || tag === "receipt"
                ? count > 1
                  ? "receipts"
                  : "receipt"
                : tag}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default Card;
